import React, { useContext } from "react";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import ColorModeContext from "../../layout/themeContext";

const useStyles = makeStyles(theme => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		backgroundColor: "#ffffff", // Fundo branco solicitado
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
	},
	logo: {
		width: "80px",
		height: "auto",
		animation: "$pulse 1.5s infinite ease-in-out",
	},
	"@keyframes pulse": {
		"0%": {
			transform: "scale(0.95)",
			opacity: 0.8,
		},
		"50%": {
			transform: "scale(1.05)",
			opacity: 1,
		},
		"100%": {
			transform: "scale(0.95)",
			opacity: 0.8,
		},
	},
}));

const BackdropLoading = () => {
	const classes = useStyles();
	const { colorMode } = useContext(ColorModeContext);
	const logoSrc = colorMode.appLogoFavicon;

	return (
		<Backdrop className={classes.backdrop} open={true}>
			{logoSrc && <img src={logoSrc} alt="Carregando..." className={classes.logo} />}
		</Backdrop>
	);
};

export default BackdropLoading;
